module.exports = __webpack_public_path__ + "img/borchia_1.613694c7.svg";